"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _select = _interopRequireWildcard(require("@amzn/meridian/select"));
var _column = _interopRequireDefault(require("@amzn/meridian/column"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FeedbackConstants = require("../constants/FeedbackConstants");
var _useResponse2 = _interopRequireDefault(require("../hooks/useResponse"));
var _formatAnswerBasedOnType = _interopRequireDefault(require("../utils/formatAnswerBasedOnType"));
var _Question = _interopRequireDefault(require("./Question"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * MultipleChoiceQuestion component will be used to provide the ability to select an option from the provided list of options.
 * @param {string} question - Question Text
 * @param {string[]} functionalities - The values of functionalities to choose from
 * @param {string} [placeholder = "Select a functionality"] -  Placeholder text in the select box
 * @returns Meridian Select Component
 */

var MultipleChoiceQuestion = function MultipleChoiceQuestion(_ref) {
  var question = _ref.question,
    id = _ref.id,
    isMandatory = _ref.isMandatory,
    functionalities = _ref.functionalities,
    placeholder = _ref.placeholder,
    questionTextFormat = _ref.questionTextFormat;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    value = _useState2[0],
    setValue = _useState2[1];
  var _useResponse = (0, _useResponse2["default"])(),
    saveFeedbackResponse = _useResponse.saveFeedbackResponse;
  var onChangeHandler = function onChangeHandler(functionality) {
    setValue(functionality);
    // This is array now in backend. Hence formating to array
    var funtionalityValue = (0, _formatAnswerBasedOnType["default"])(functionality, true);
    saveFeedbackResponse({
      id: id,
      answer: funtionalityValue
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_column["default"], {
    spacingInset: "xxsmall"
  }, /*#__PURE__*/_react["default"].createElement(_Question["default"], {
    questionTextFormat: questionTextFormat,
    question: question,
    isMandatory: isMandatory
  }), /*#__PURE__*/_react["default"].createElement(_select["default"], {
    id: "functionalities",
    value: value,
    onChange: function onChange(key) {
      return onChangeHandler(key);
    },
    placeholder: placeholder,
    width: 300,
    spacingInset: "medium"
  }, functionalities.map(function (_ref2) {
    var optionNumber = _ref2.optionNumber,
      optionValue = _ref2.optionValue;
    return /*#__PURE__*/_react["default"].createElement(_select.SelectOption, {
      key: optionNumber,
      label: optionValue,
      value: optionNumber
    });
  })));
};
MultipleChoiceQuestion.propTypes = {
  question: _propTypes["default"].string.isRequired,
  id: _propTypes["default"].string.isRequired,
  isMandatory: _propTypes["default"].bool.isRequired,
  functionalities: _propTypes["default"].array.isRequired,
  placeholder: _propTypes["default"].string,
  questionTextFormat: _propTypes["default"].string
};
MultipleChoiceQuestion.defaultProps = {
  placeholder: _FeedbackConstants.PLACEHOLDERS.multipleChoiceQuestionType,
  questionTextFormat: ''
};
var _default = exports["default"] = MultipleChoiceQuestion;
//# sourceMappingURL=MultipleChoiceQuestion.js.map